var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24177_25691)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.458,
    height: 180,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.458,
    height: 180,
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.229004,
    width: 180,
    height: 180,
    rx: 11,
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.983 51.681C61.1 51.6822 66.217 51.6822 71.334 51.681C73.0694 51.6806 74.252 51.6804 75.2846 51.8625C80.2283 52.7342 84.0988 56.6047 84.9705 61.5484C85.1526 62.581 85.1523 63.7635 85.152 65.499C85.1519 65.8772 85.1635 66.258 85.0975 66.6321C84.836 68.1152 83.6748 69.2763 82.1917 69.5378C81.8665 69.5952 81.5239 69.5934 81.3535 69.5924C69.5581 69.5293 57.7589 69.5293 45.9635 69.5924C45.7931 69.5934 45.4505 69.5952 45.1253 69.5378C43.6422 69.2763 42.481 68.1152 42.2195 66.6321C42.1535 66.258 42.1651 65.8772 42.165 65.499C42.1647 63.7635 42.1644 62.581 42.3465 61.5484C43.2182 56.6047 47.0887 52.7342 52.0324 51.8625C53.065 51.6804 54.2476 51.6806 55.983 51.681Z",
    fill: "#8BBAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5236 34.964C50.5236 27.7098 56.4043 21.8291 63.6585 21.8291C70.9127 21.8291 76.7934 27.7098 76.7934 34.964C76.7934 42.2182 70.9127 48.0988 63.6585 48.0988C56.4043 48.0988 50.5236 42.2182 50.5236 34.964Z",
    fill: "#8BBAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.983 128.103C61.1 128.104 66.217 128.104 71.334 128.103C73.0694 128.102 74.252 128.102 75.2846 128.284C80.2283 129.156 84.0988 133.026 84.9705 137.97C85.1526 139.003 85.1523 140.185 85.152 141.921C85.1519 142.299 85.1635 142.68 85.0975 143.054C84.836 144.537 83.6748 145.698 82.1917 145.959C81.8665 146.017 81.5239 146.015 81.3535 146.014C69.5581 145.951 57.7589 145.951 45.9635 146.014C45.7931 146.015 45.4505 146.017 45.1253 145.959C43.6422 145.698 42.481 144.537 42.2195 143.054C42.1535 142.68 42.1651 142.299 42.165 141.921C42.1647 140.185 42.1644 139.003 42.3465 137.97C43.2182 133.026 47.0887 129.156 52.0324 128.284C53.065 128.102 54.2476 128.102 55.983 128.103Z",
    fill: "#8BBAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5236 111.386C50.5236 104.131 56.4043 98.2507 63.6585 98.2507C70.9127 98.2507 76.7934 104.131 76.7934 111.386C76.7934 118.64 70.9127 124.52 63.6585 124.52C56.4043 124.52 50.5236 118.64 50.5236 111.386Z",
    fill: "#8BBAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.668 93.076C124.785 93.0772 129.902 93.0772 135.019 93.076C136.754 93.0757 137.937 93.0754 138.969 93.2575C143.913 94.1292 147.784 97.9998 148.655 102.943C148.837 103.976 148.837 105.159 148.837 106.894C148.837 107.272 148.848 107.653 148.782 108.027C148.521 109.51 147.36 110.671 145.877 110.933C145.551 110.99 145.209 110.988 145.038 110.987C133.243 110.924 121.444 110.924 109.648 110.987C109.478 110.988 109.135 110.99 108.81 110.933C107.327 110.671 106.166 109.51 105.904 108.027C105.838 107.653 105.85 107.272 105.85 106.894C105.849 105.159 105.849 103.976 106.031 102.943C106.903 97.9998 110.774 94.1292 115.717 93.2575C116.75 93.0754 117.932 93.0757 119.668 93.076Z",
    fill: "#0369FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.208 76.359C114.208 69.1048 120.089 63.2241 127.343 63.2241C134.597 63.2241 140.478 69.1048 140.478 76.359C140.478 83.6132 134.597 89.4939 127.343 89.4939C120.089 89.4939 114.208 83.6132 114.208 76.359Z",
    fill: "#0369FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 179.458,
    height: 179,
    rx: 10.5,
    stroke: "#DFE1E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24177_25691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.458,
    height: 180,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextAvailable);
export default __webpack_public_path__ + "static/media/nextAvailable.a2d64b0e417c54b706e74e75ce6d345a.svg";
export { ForwardRef as ReactComponent };